import { injectable } from "inversify";
import StablishmentRepository from "../../../domain/repositories/StablishmentRepository";
import { Either } from "fp-ts/lib/Either";
import ErrorEntity from "../../../domain/entities/ErrorEntity";
import StablishmentEntity from "../../../domain/entities/StablishmentEntity";
import SearchResultEntity from "../../../domain/entities/SearchResultEntity";
import SearchStablishmentsApiImpl from "./api/SearchStablishmentsApiImpl";
import CreateStablishmentApiImpl from "./api/CreateStablishmentApiImpl";
import GetStablishmentByIdApiImpl from "./api/GetStablishmentByIdApiImpl";
import DeleteStablishmentApiImpl from "./api/DeleteStablishmentApiImpl";
import UpdateStablishmentApiImpl from "./api/UpdateStablishmentApiImpl";
import DeleteScheduleApiImpl from "./api/DeleteScheduleApiImpl";
import ScheduleEntity, { ScheduleDay } from "../../../domain/entities/ScheduleEntity";
import GetSchedulesByDateAndStablishmentApiImpl from "./api/GetSchedulesByDateAndStablishmentApiImpl";

@injectable()
export default class StablishmentRepositoryImpl implements StablishmentRepository {
    getSchedulesByStablishmentAndDay = async (stablishmentId: string, day: Date): Promise<Either<ErrorEntity, ScheduleEntity[]>> => GetSchedulesByDateAndStablishmentApiImpl(stablishmentId, day);
    deleteSchedule(id: string): Promise<Either<ErrorEntity, void>> {
        return DeleteScheduleApiImpl(id);
    }
    getStablishmentById(id: string): Promise<Either<ErrorEntity, StablishmentEntity>> {
        throw new Error("Method not implemented.");
    }
    createStablishment = async (stablishment: StablishmentEntity): Promise<Either<ErrorEntity, StablishmentEntity>> => CreateStablishmentApiImpl(stablishment);
    searchStablishments = async (_: {
        query?: string,
        page: number,
        itemsPerPage: number
    }): Promise<Either<ErrorEntity, SearchResultEntity<StablishmentEntity>>> => SearchStablishmentsApiImpl(_);
    deleteStablishment = async (id: string): Promise<Either<ErrorEntity, void>> => DeleteStablishmentApiImpl(id);
    updateStablishment = async (stablishment: StablishmentEntity): Promise<Either<ErrorEntity, StablishmentEntity>> => UpdateStablishmentApiImpl(stablishment);
}